// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#testimonial-component-drawer .photo-uploader .ant-upload.ant-upload-select-picture-card{\n\twidth: 100%;\n\theight: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
